module.exports = __webpack_public_path__ + "img/bus.a852f431.svg";